import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getAllConfigurableverbaige, savePortalVerbiageConfiguration } from 'src/redux/async'
import {
  changeDefaultTemplate,
  createRFPProjectInformationAsync,
  editRFPProjectInformationAsync,
  getAllRemindersDataForRFPAsync,
  getBidAnalysisHistoryAsync,
  getDefaultTemplate,
  uploadBidAnalysisProofAsync,
  getProjectsDetailsAsync,
} from 'src/redux/async/rfxManagement/rfpManagementAsync'
import {
  changeRFIDefaultTemplate,
  createProjectInformationAsync,
  editProjectInformationAsync,
  getReminders,
  getRFIDefaultTemplate,
  getProjectsDetailsAsync as getRFIProjectDetailsAsync,
} from 'src/redux/async/rfxManagement/rfxManagementAsync'

const initialState = {
  initialProjectDetails: null,
  createProjectType: null, // type one of 'rfp'=> for rfp project or 'rfi'=> rfi project
  projectMode: 'I', // mode one of 'I'=> for new create or 'E'=> for edit project
  selectedTab: 1,
  projectDetailsSaveStatus: false,
  projectDetailsSaveLoader: false,
  getInfoLoader: false,
  rfpSent: false,
  originalDetails: null,
  failedGettingInfo: false,
  uploadBidProofOfApproval: false,
  historyBidProofOfApproval: false,
  isSaveButtonDisable: false,
  isSaveActionDisabled:false,
  isProjectArchived:false
}

export const createProjectSlice = createSlice({
  name: 'rfx-create-project-new',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(editRFPProjectInformationAsync.pending), (state) => {
      state.projectDetailsSaveLoader = true
    })
    builder.addMatcher(isAnyOf(editRFPProjectInformationAsync.fulfilled), (state, action) => {
      state.projectDetailsSaveLoader = false
      state.projectDetailsSaveStatus = true
    })
    builder.addMatcher(isAnyOf(editRFPProjectInformationAsync.rejected), (state, action) => {
      state.projectDetailsSaveLoader = false
    })
    builder.addMatcher(isAnyOf(editProjectInformationAsync.pending), (state) => {
      state.projectDetailsSaveLoader = true
    })
    builder.addMatcher(isAnyOf(editProjectInformationAsync.fulfilled), (state, action) => {
      state.projectDetailsSaveLoader = false
      state.projectDetailsSaveStatus = true
    })
    builder.addMatcher(isAnyOf(editProjectInformationAsync.rejected), (state, action) => {
      state.projectDetailsSaveLoader = false
    })

    builder.addMatcher(isAnyOf(createRFPProjectInformationAsync.pending), (state) => {
      state.projectDetailsSaveLoader = true
    })
    builder.addMatcher(isAnyOf(createRFPProjectInformationAsync.fulfilled), (state, action) => {
      state.projectDetailsSaveLoader = false
      state.projectDetailsSaveStatus = true
    })
    builder.addMatcher(isAnyOf(createRFPProjectInformationAsync.rejected), (state, action) => {
      state.projectDetailsSaveLoader = false
    })

    builder.addMatcher(isAnyOf(createProjectInformationAsync.pending), (state) => {
      state.projectDetailsSaveLoader = true
    })
    builder.addMatcher(isAnyOf(createProjectInformationAsync.fulfilled), (state, action) => {
      state.projectDetailsSaveLoader = false
      state.projectDetailsSaveStatus = true
    })
    builder.addMatcher(isAnyOf(createProjectInformationAsync.rejected), (state, action) => {
      state.projectDetailsSaveLoader = false
    })

    builder.addMatcher(isAnyOf(getProjectsDetailsAsync.pending), (state) => {
      state.failedGettingInfo = false
      state.getInfoLoader = true
    })
    builder.addMatcher(isAnyOf(getProjectsDetailsAsync.fulfilled), (state, action) => {
      state.failedGettingInfo = false
      state.getInfoLoader = false
    })
    builder.addMatcher(isAnyOf(getProjectsDetailsAsync.rejected), (state, action) => {
      state.failedGettingInfo = true
      state.getInfoLoader = false
    })

    builder.addMatcher(isAnyOf(getRFIProjectDetailsAsync.pending), (state) => {
      state.failedGettingInfo = false
      state.getInfoLoader = true
    })
    builder.addMatcher(isAnyOf(getRFIProjectDetailsAsync.fulfilled), (state, action) => {
      state.failedGettingInfo = false
      state.getInfoLoader = false
    })
    builder.addMatcher(isAnyOf(getProjectsDetailsAsync.rejected), (state, action) => {
      state.failedGettingInfo = true
      state.getInfoLoader = false
    })

    builder.addMatcher(isAnyOf(getAllRemindersDataForRFPAsync.pending), (state) => {
      state.getInfoLoader = true
    })

    builder.addMatcher(isAnyOf(getAllRemindersDataForRFPAsync.fulfilled), (state) => {
      state.getInfoLoader = false
    })
    builder.addMatcher(isAnyOf(getAllRemindersDataForRFPAsync.rejected), (state) => {
      state.getInfoLoader = false
    })

    builder.addMatcher(isAnyOf(getReminders.pending), (state) => {
      state.getInfoLoader = true
    })

    builder.addMatcher(isAnyOf(getReminders.fulfilled), (state) => {
      state.getInfoLoader = false
    })
    builder.addMatcher(isAnyOf(getReminders.rejected), (state) => {
      state.getInfoLoader = false
    })

    builder.addMatcher(isAnyOf(uploadBidAnalysisProofAsync.pending), (state) => {
      state.uploadBidProofOfApproval = true
    })
    builder.addMatcher(isAnyOf(uploadBidAnalysisProofAsync.fulfilled), (state, action) => {
      state.uploadBidProofOfApproval = false
    })
    builder.addMatcher(isAnyOf(uploadBidAnalysisProofAsync.rejected), (state, action) => {
      state.uploadBidProofOfApproval = false
    })

    builder.addMatcher(isAnyOf(getBidAnalysisHistoryAsync.pending), (state) => {
      state.historyBidProofOfApproval = true
    })
    builder.addMatcher(isAnyOf(getBidAnalysisHistoryAsync.fulfilled), (state, action) => {
      state.historyBidProofOfApproval = false
    })
    builder.addMatcher(isAnyOf(getBidAnalysisHistoryAsync.rejected), (state, action) => {
      state.historyBidProofOfApproval = false
    })
    builder.addMatcher(isAnyOf(savePortalVerbiageConfiguration.pending), (state) => {
      state.projectDetailsSaveLoader = true
    })
    builder.addMatcher(isAnyOf(savePortalVerbiageConfiguration.fulfilled), (state) => {
      state.projectDetailsSaveLoader = false
    })
    builder.addMatcher(isAnyOf(savePortalVerbiageConfiguration.rejected), (state) => {
      state.projectDetailsSaveLoader = false
    })

    builder.addMatcher(isAnyOf(getAllConfigurableverbaige.pending), (state) => {
      state.isSaveButtonDisable = true
    })
    builder.addMatcher(isAnyOf(getAllConfigurableverbaige.fulfilled), (state) => {
      state.isSaveButtonDisable = false
    })
    builder.addMatcher(isAnyOf(getAllConfigurableverbaige.rejected), (state) => {
      state.isSaveButtonDisable = false
    })

    builder.addMatcher(isAnyOf(getDefaultTemplate.pending), (state) => {
      state.isSaveButtonDisable = true
    })
    builder.addMatcher(isAnyOf(getDefaultTemplate.fulfilled), (state) => {
      state.isSaveButtonDisable = false
    })
    builder.addMatcher(isAnyOf(getDefaultTemplate.rejected), (state) => {
      state.isSaveButtonDisable = false
    })
    builder.addMatcher(isAnyOf(getRFIDefaultTemplate.pending), (state) => {
      state.isSaveButtonDisable = true
    })
    builder.addMatcher(isAnyOf(getRFIDefaultTemplate.fulfilled), (state) => {
      state.isSaveButtonDisable = false
    })
    builder.addMatcher(isAnyOf(getRFIDefaultTemplate.rejected), (state) => {
      state.isSaveButtonDisable = false
    })

    builder.addMatcher(isAnyOf(changeDefaultTemplate.pending), (state) => {
      state.projectDetailsSaveLoader = true
    })
    builder.addMatcher(isAnyOf(changeDefaultTemplate.fulfilled), (state, action) => {
      state.projectDetailsSaveLoader = false
    })
    builder.addMatcher(isAnyOf(changeDefaultTemplate.rejected), (state, action) => {
      state.projectDetailsSaveLoader = false
    })

    builder.addMatcher(isAnyOf(changeRFIDefaultTemplate.pending), (state) => {
      state.projectDetailsSaveLoader = true
    })
    builder.addMatcher(isAnyOf(changeRFIDefaultTemplate.fulfilled), (state, action) => {
      state.projectDetailsSaveLoader = false
    })
    builder.addMatcher(isAnyOf(changeRFIDefaultTemplate.rejected), (state, action) => {
      state.projectDetailsSaveLoader = false
    })
  },
  reducers: {
    setInitialProjectDetails: (state, action) => {
      state.initialProjectDetails = action.payload
    },
    setSaveActionDisable: (state, action) => {
      state.isSaveActionDisabled = action.payload
    },
    setProjectType: (state, action) => {
      state.createProjectType = action.payload
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload
    },
    setRfpSent: (state, action) => {
      state.rfpSent = action.payload
    },
    setOriginalDetails: (state, action) => {
      state.originalDetails = action.payload
    },
    setIsProjectArchived:(state,action)=>{
      state.isProjectArchived= action.payload
    },
    setProjectMode: (state, action) => {
      state.projectMode = action.payload
      if (action.payload === '') {
        state.getInfoLoader = true
      }
    },
    setToInitial: (state, action) => {
      state.initialProjectDetails = null
      // state.createProjectType = null // type one of 'rfp'=> for rfp project or 'rfi'=> rfi project
      state.projectMode = 'I' // mode one of 'I'=> for new create or 'E'=> for edit project
      state.selectedTab = 1
      state.projectDetailsSaveStatus = false
      state.projectDetailsSaveLoader = false
      state.getInfoLoader = false
      state.rfpSent = false
      state.originalDetails = null
      state.failedGettingInfo = false
      state.uploadBidProofOfApproval = false
      state.historyBidProofOfApproval = false
      state.isSaveButtonDisable = false
      state.isSaveActionDisabled =false
    },
  },
})
export const {
  setProjectType,
  setSelectedTab,
  setInitialProjectDetails,
  setRfpSent,
  setOriginalDetails,
  setProjectMode,
  setToInitial,
  setSaveActionDisable,
  setIsProjectArchived
} = createProjectSlice.actions
export default createProjectSlice.reducer
